import { X, Download } from "lucide-react";
import { fmtShortDate } from "../lib/format";
import { krOre, INVOICE_STATUS } from "../lib/billing";
import { Pill } from "./bits";

const Party = ({ title, p }) => (
  <div className="iv-party">
    <small>{title}</small>
    <b>{p.company}</b>
    <span>{p.address}</span>
    <span>{p.zip_city}</span>
    <span>CVR {p.cvr}</span>
    {p.ean && <span>EAN {p.ean}</span>}
    {p.reference && <span>Ref.: {p.reference}</span>}
    <span className="muted">{p.email || p.contact_email}</span>
  </div>
);

export default function InvoiceView({ inv, onClose, onDownload }) {
  const [cls, label] = INVOICE_STATUS[inv.status] || ["draft", inv.status];
  return (
    <div className="ck-overlay" role="dialog" aria-modal="true" data-testid="invoice-view">
      <div className="ck-modal" style={{ maxWidth: 640 }}>
        <div className="ck-head">
          <div className="ck-brand"><b>Faktura {inv.number}</b> <Pill status={cls} label={label} /></div>
          <button className="ck-close" onClick={onClose} aria-label="Luk" data-testid="invoice-view-close"><X size={18} /></button>
        </div>
        <div className="ck-body iv-body">
          <div className="iv-parties">
            <Party title="Faktureres til" p={inv.buyer} />
            <Party title="Fra" p={inv.seller} />
          </div>
          <div className="iv-meta">
            <div><small>Fakturadato</small><b>{fmtShortDate(inv.issue_date)}</b></div>
            <div><small>Forfaldsdato</small><b>{fmtShortDate(inv.due_date)}</b></div>
            <div><small>Periode</small><b>{inv.period_label}</b></div>
          </div>
          {inv.lines.map((l, i) => (
            <div className="iv-line" key={i}><span>{l.text}</span><b>{krOre(l.net_ore)}</b></div>
          ))}
          <div className="iv-tot"><span>Subtotal ekskl. moms</span><span>{krOre(inv.net_ore)}</span></div>
          <div className="iv-tot"><span>Moms {inv.vat_pct} %</span><span>{krOre(inv.vat_ore)}</span></div>
          <div className="iv-tot big" data-testid="invoice-view-total"><span>Total inkl. moms</span><span>{krOre(inv.total_ore)}</span></div>
          <div className="iv-pay">
            <b>Betaling</b>
            <span>Bankoverførsel · Reg.nr. {inv.payment.reg_nr} · Kontonr. {inv.payment.account_nr}</span>
            <span>Angiv fakturanr. {inv.number} ved betaling.</span>
          </div>
          <button className="btn primary" onClick={onDownload} data-testid="invoice-view-download"><Download size={16} /> Hent PDF</button>
        </div>
      </div>
    </div>
  );
}
